<template>
    <section class="administrator-item" :class="{'selected': selected, 'disabled': isOutOfLicence && !selected}" v-tooltip="getTooltip">
        <section class="administrator-item__avatar">
            <img :src="item.avatar" :alt="getUser" />
        </section>
        <section class="administrator-item__data">
            <span class="administrator-item__data__user">{{ getUser }}</span>
        </section>
    </section>
</template>
<script charset="utf-8">
    export default {
        name: "AdministratorItem",
        props: {
            item: {
                type: Object,
                default() {
                    return {
                        id: "",
                        firstName: "",
                        lastName: "",
                        login: "",
                        lastLoginDate: "",
                        lid: "",
                        avatar: ""
                    }
                }
            },
            selected: {
                type: Boolean,
                default: false,
            },
            isOutOfLicence: {
                type: Boolean,
                default: false,
            }
        },
        computed: {
            getUser() {
                return `${this.item.firstName} ${this.item.lastName}`
            },
            getTooltip() {
                if (this.isOutOfLicence && !this.selected) {
                    return `Przekroczono limit administratorów. Zablokowano dalszy wybór.`;
                }
                return `${this.item.firstName} ${this.item.lastName}`
            }
        }
    }
</script>
<style lang="scss" scoped>
    .administrator-item {
        display: flex;
        background: #fff;
        width: 200px;
        column-gap: 10px;
        cursor: pointer;

        &:hover {
            box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        }

        &__avatar {
            img {
                width: 50px;
            }
        }
    }

    .disabled {
        cursor: default;

        &:hover {
            box-shadow: none !important;
        }
    }
        .selected {
            background: #caffc1;
        }
</style>